import { columnTypes } from '@/services/Grid/ColumnTypes';

export const jobGridColumnTypes = columnTypes;

export const jobDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};

export const jobGridColumns = [
  {
    headerName: 'ID',
    field: 'jobId',
    width: 100,
    minWidth: 100,
  },
  {
    headerName: 'Job Title',
    field: 'job',
    minWidth: 250,
  },
  {
    headerName: 'Assessment Type',
    field: 'assessmentType',
    width: 200,
    minWidth: 200,
  },
  {
    headerName: 'Total Properties',
    field: 'numProperties',
    width: 150,
    minWidth: 150,
  },
  {
    headerName: 'Issued to Client',
    field: 'numAssessmentsFinalised',
    width: 150,
    minWidth: 150,
  },
  {
    headerName: 'Unassigned',
    field: 'numPropertiesInUnassignedStatus',
    width: 150,
    minWidth: 150,
  },
  {
    headerName: 'Assigned',
    field: 'numPropertiesInAssignedStatus',
    width: 150,
    minWidth: 150,
  },
  {
    headerName: 'VS1',
    field: 'numAssessmentsValidatedStageOne',
    width: 100,
    minWidth: 100,
  },
  {
    headerName: 'VS2',
    field: 'numAssessmentsValidatedStageTwo',
    width: 100,
    minWidth: 100,
  },
];
